export const config = {
  portfolio: {
    portfolioLogo: "Portfolio",
    projectCard: {
      cards: [
        {
          heading: "🌾 KissanGPT 🌾",
          description:
            "KissanGPT is an AI-powered chatbot built to assist farmers, agricultural workers, and enthusiasts with practical advice on farming, crop cultivation, soil management, pest control, irrigation, and agricultural technology. By leveraging Meta's Llama model, KisanGPT delivers accurate, detailed, and easy-to-understand guidance tailored to your agricultural needs.",
          animationDelay: "300",
          buttonLink:
            "https://kissangpt.streamlit.app",
          buttonText: "CHAT NOW 💬",
        },
        {
          heading: "🌱 Agrilens 🌱",
          description:
            "AgriLens: An AI-powered tool using Meta's LLAMA 3.2 LLM to analyze agricultural images, offering insights on crop health, pest management, and actionable farming recommendations.",
          animationDelay: "500",
          buttonLink:
            "https://agrilens.streamlit.app",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Super Resolution Image using ESRGAN",
          description:
            "The Project aim is to Generate High Resolution image of Low resolution image. For this task I implement ESRGAN using PyTorch from scratch. I also made web app using streamlit and also created an API using FastAPI.",
          animationDelay: "700",
          buttonLink:
            "https://github.com/AquibPy/Enhanced-Super-Resolution-GAN",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Satellite Image to Google Map using Pix2Pix",
          description:
            "In this project, I used Pix2Pix Conditional GAN to generate satellite image to Google Map. The project is implemented using PyTorch. I had also created a web app for this project in which I used FastAPI to create API for the model and streamlit for UI. ",
          animationDelay: "900",
          buttonLink: "https://github.com/AquibPy/Pix2Pix-Conditional-GANs",
          buttonText: "CHECK OUT",
        },
        {
          heading: "HaSa",
          description:
            "HaSa is an web application based on simple machine learning algorithms like Naive Bayes Algorithm and NLP techniques which specifies whether a given text is depressing or not. Deployed on Docker and Railway and also built CI/CD pipeline. ",
          animationDelay: "1100",
          buttonLink: "https://github.com/AquibPy/HaSa",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Genify",
          description: "Genify is a powerful and versatile API developed by Mohd Aquib that leverages advanced language models, including Google's Gemini 1.5 Pro, LLAMA 3 and other cutting-edge technologies, to deliver a wide range of natural language processing capabilities. This innovative API offers a comprehensive suite of routes for various AI-powered use cases, such as invoice extraction, question answering, video transcription and summarization, blog generation, SQL query generation, and more. With its user-friendly interfaces and intuitive functionality, Genify streamlines and enhances diverse tasks, empowering users to harness the full potential of generative AI models for enhanced productivity and efficiency.",
          animationDelay: "1300",
          buttonLink: "https://github.com/AquibPy/Genify",
          buttonText: "CHECK OUT",
        },
        {
          heading: "Chat with LLAMA 3  🦙🦙🦙",
          description: "This is a cutting-edge web application that harnesses the power of state-of-the-art large language models (LLMs), including LLAMA 3-70b, LLAMA 3-8b, MIXTRAL 8x7b, and GEMMA 7b-it, to provide users with an immersive and interactive conversational experience, seamlessly blending advanced natural language processing capabilities with a visually captivating and highly responsive user interface that offers a wide array of customization options, such as dark mode, message copying functionality, and dynamic model selection.",
          animationDelay: "1500",
          buttonLink: "https://llm-pgc4.onrender.com/chatbot",
          buttonText: "CHAT NOW 💬",
        },
        {
          heading: "Smart ATS powered by GenAI",
          description: "Smart ATS is a powerful web application designed for job seekers that utilizes Google's advanced Gemini 1.5 Pro large language model (LLM) to provide a comprehensive analysis of their resume before applying for a job. It offers valuable insights such as an ATS (Applicant Tracking System) score, identifies missing keywords relevant to the job description, recommends improvements to the resume, and even suggests potential technical interview questions. With Smart ATS, job seekers can optimize their resume and better prepare themselves for the application and interview process, increasing their chances of standing out to potential employers.",
          animationDelay: "1700",
          buttonLink: "https://llm-pgc4.onrender.com/ats",
          buttonText: "CHECK OUT",
        },
        {
          heading: "GenAI Blog Wizard",
          description: "GenAI Blog Wizard is a powerful web application that utilizes Google's advanced Gemini 1.5 Pro large language model to generate high-quality, engaging blog content on any topic with unprecedented ease and efficiency.",
          animationDelay: "1900",
          buttonLink: "https://llm-pgc4.onrender.com/blog_generator_ui",
          buttonText: "CHECK OUT",
        },
        {
          heading: "URL Shortener with Go Fiber and Redis",
          description: "This is a URL shortener service built with the Go Fiber framework and Redis. It provides a simple API to shorten URLs and resolve shortened URLs. The service includes rate limiting and URL validation features.",
          animationDelay: "2100",
          buttonLink: "https://github.com/AquibPy/shorten-url-fiber-redis",
          buttonText: "CHECK OUT",
        },
        {
          heading: "🎥 Movie Recommender System 🎥",
          description: "This project is a Movie Recommender System built with Python and Streamlit. It uses BERT embeddings and cosine similarity to recommend movies that are similar to a selected movie.",
          animationDelay: "2300",
          buttonLink: "https://movie-recommender-system-wyrm.onrender.com",
          buttonText: "CHECK OUT",
        },
      ],
    },
    internships: {
      internship: [
        {
          companyName: "Wobot Intelligence",
          role: "Computer Vision Intern",
          introText: "",
          duration: "10/2021 - 03/2022",
          keyPointOne:
            "Implemented YOLOv5 for real-time vehicle detection within specified Regions of Interest (ROIs)",
          keyPointTwo:
            "Employed object detection algorithms to differentiate between occupied and vacant parking spaces.",
          keyPointThree:
            "Developed functionality for automatic counting of occupied and vacant ROIs.",
          keyPointFour:
            "Enhanced parking management systems by integrating advanced computer vision methodologies for accurate vehicle detection and space utilization analysis.",
          offsetValue: "0",
        },
      ],
    },
  },
};

export default config;
